import styled from 'styled-components';

type Props = {};
type PropsGalleryItem = {
  height: number;
  width: number;
};
export default styled.section<Props>`
  .images {
    display: grid;
    gap: 2px;
    grid-template-columns: 135px repeat(auto-fill, 135px) 135px;
  }
  .scroll-images {
  }
  @media only screen and (min-width: 1441px) {
    .scroll-images {
    }
  }
`;

export const GalleryItem = styled.div<PropsGalleryItem>`
  height: ${(props) => props?.height - 1}px;
  position: relative;
  .image {
    width: 135px;
    height: 135px;
    &.cursor-pointer {
      cursor: pointer;
    }
  }

  .gallery-item-header {
    position: absolute;
    width: 135px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px;
    z-index: 1;
    .status {
      height: 24px;
      width: 56px;
      border-radius: 12px;
      background-color: rgba(0, 0, 0, 0.4);
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      letter-spacing: 0;
      line-height: 18px;
      color: var(--white);
    }
    .round {
      position: relative;
      label {
        border: 1px solid #979797;
        background-color: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        cursor: pointer;
        height: 24px;
        left: 0;
        position: absolute;
        top: 0;
        width: 24px;
        &::after {
          border: 2px solid #fff;
          border-top: none;
          border-right: none;
          content: '';
          height: 6px;
          left: 5px;
          opacity: 0;
          position: absolute;
          top: 7px;
          transform: rotate(-45deg);
          width: 12px;
        }
      }
      input[type='checkbox'] {
        visibility: hidden;
      }
      input[type='checkbox']:checked + label {
        background-color: #000000;
        border: 1px solid #000000;
      }
      input[type='checkbox']:checked + label:after {
        opacity: 1;
      }
    }
  }
  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.4);
    top: 0;
    left: 0;
  }
`;
